import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { INVALID_MESSAGE } from './constants';
import { isAdobeRegCode, isOneIdRegCode } from './util';
import {
    checkAdobeRegCode,
    checkOneIdRegCode,
    completeSubmit,
    createInvalidErrorAction,
    createGenericErrorAction,
    regCodeUpdate,
    startSubmit
} from './actions';
import * as oneId from 'lib/oneId';

export class ActivationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAdobeRegCode: false,
            regCode: this.props.regCode.toUpperCase(),
            regCodeError: false
        };
        this.onCodeChange = this.onCodeChange.bind(this);
        this.onCodeKeyUp = this.onCodeKeyUp.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.renderHeading = this.renderHeading.bind(this);
    }

    componentDidMount() {
        const { regCode } = this.state;

        if (regCode) {
            this.onSubmit();
        }
    }

    onCodeChange(event) {
        const regCode = event.target.value.toUpperCase();
        this.props.dispatch(regCodeUpdate(regCode));
        this.setState({
            regCode,
            regCodeError: false
        });
    }

    onCodeKeyUp(event) {
        if (event.which === 13) {
            this.onSubmit();
        }
    }

    async onSubmit() {
        const { regCode } = this.state;
        const {
            adobePassEnv,
            deviceType,
            dispatch,
            submitting,
            commerceUrlsConfig,
            query
        } = this.props;
        if (submitting) {
            return;
        }
        const regCodeError = !regCode;
        if (regCodeError) {
            this.setState({ regCodeError });
            return;
        }

        dispatch(startSubmit());
        try {
            if (isAdobeRegCode(regCode)) {
                await dispatch(checkAdobeRegCode(regCode, adobePassEnv));
            } else if (isOneIdRegCode(regCode)) {
                await dispatch(checkOneIdRegCode(
                    deviceType,
                    regCode,
                    commerceUrlsConfig,
                    query
                ));
            } else {
                dispatch(createInvalidErrorAction(INVALID_MESSAGE));
            }
        } catch (err) {
            if (oneId.Error.CANCEL_BY_USER !== err) {
                if (oneId.Error.UNKNOWN_ERROR === err) {
                    dispatch(createGenericErrorAction(err));
                } else {
                    dispatch(createInvalidErrorAction(err.message || INVALID_MESSAGE));
                }
            }
        }
        dispatch(completeSubmit());
    }

    renderHeading() {
        const { activatePageType } = this.props;
        const text = (activatePageType === 'subscribe') ?
            'Complete Your Subscription' : 'Activate Device';
        return <h1 className="dtc-auth__header__title">{text}</h1>;
    }

    renderErrorMessage(hasError) {
        if (!hasError) {
            return null;
        }
        const {
            genericError,
            invalidError
        } = this.props;
        const { regCodeError } = this.state;

        if (genericError) {
            return (
                <div id="generic-error" className="dtc-form__error">
                    <p>An error occurred. Please try again later.</p>
                </div>
            );
        } else if (!genericError && invalidError) {
            return (
                <div id="invalid-activation-code" className="dtc-form__error">
                    <p>Invalid activation code!</p>
                </div>
            );
        } else if (!genericError && regCodeError) {
            return (
                <div id="no-activation-code" className="dtc-form__error">
                    <p>Please enter an activation code.</p>
                </div>
            );
        }
        return null;
    }

    render() {
        const {
            genericError,
            invalidError,
            activatePageType
        } = this.props;
        const {
            regCode,
            regCodeError
        } = this.state;

        let errorClassName = '';

        const isDisabled = (regCode) ? '' : 'dtc-btn--disabled';
        const isSubscribeActivation = (activatePageType === 'subscribe');
        const hasError = genericError || invalidError || regCodeError;
        if (hasError) {
            errorClassName = 'dtc-form__control--error';
        }

        const buttonClasses = classnames({
            'dtc-btn': !isSubscribeActivation,
            'dtc-btn--disabled': !regCode,
            'btn btn-primary': isSubscribeActivation
        });

        return (
            <div>
                <header className="dtc-auth__header" id="page-title">
                    {this.renderHeading()}
                </header>
                <section className="dtc-auth__section" id="enter-code">
                    <h2 className="dtc-auth__section__title">Enter the code displayed on your TV screen.</h2>
                    <input
                        className={`dtc-form__control ${errorClassName}`}
                        ref={input => { this.txtRegCode = input; }}
                        id="txtRegCode"
                        name="txtRegCode"
                        type="text"
                        maxLength="7"
                        placeholder={'Enter Activation Code'}
                        value={this.state.regCode}
                        onChange={this.onCodeChange}
                        onKeyUp={this.onCodeKeyUp}
                    />
                    {this.renderErrorMessage(hasError)}
                </section>
                <section className="section" id="authenticate">
                    <button
                        id="cont-btn"
                        name="submit"
                        type="submit"
                        className={buttonClasses}
                        onClick={this.onSubmit}
                        disabled={isDisabled}
                    >Continue</button>
                </section>
            </div>
        );
    }
}

ActivationComponent.propTypes = {
    adobePassEnv: PropTypes.string,
    deviceType: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    genericError: PropTypes.string,
    invalidError: PropTypes.string,
    submitting: PropTypes.bool,
    commerceUrlsConfig: PropTypes.object,
    activatePageType: PropTypes.string,
    regCode: PropTypes.string,
    query: PropTypes.object
};

ActivationComponent.defaultProps = {
    providers: [],
    regCode: ''
};

const mapStateToProps = (state) => {
    const {
        providerDialog: { providers = [] } = {},
        activation: { genericError = {}, invalidError, submitting },
        app = {}
    } = state;
    const {
        country,
        lang,
        location: { query = {} } = {},
        bootstrap: { bam: { commerceUrls } = {} } = {}
    } = app;

    return {
        genericError,
        invalidError,
        providers,
        submitting,
        query,
        commerceUrlsConfig: { ...{ urls: commerceUrls }, ...{ lang, country } }
    };
};

export default connect(mapStateToProps)(ActivationComponent);



// WEBPACK FOOTER //
// ./app/webapp/page/Activate/Activation.js